import React from 'react';

// `fixed` renders one viewport-pinned layer for the whole page. Sections above it
// stay transparent so the texture reads as continuous, without per-section
// `background-attachment: fixed` (ignored on iOS, repaints on every scroll elsewhere).
export default function TextureOverlay({
  src = '/flow-assets/content/coffee-powder-texture-light.jpg',
  opacity = 0.1,
  fixed = false
}) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none ${fixed ? 'fixed' : 'absolute'} inset-0`}
      style={{
        backgroundImage: `url('${src}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: fixed ? 'scroll' : 'fixed',
        opacity
      }}
    />
  );
}
